

import React from 'react';
import { Spin } from 'antd';
import moment from 'moment';

const CampaignDetails = (props) => {
  const { data, loading } = props;
  const { id, title, story, amount, progress, deadline, visitors, cover_photo: coverPhoto } = data || {};
  const cover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${coverPhoto}`;
  const daysGone = deadline ? `${Math.abs(moment(deadline).diff(moment(), 'days'))} days to go...` : 'N/A';
  return (
    <div>
      <section className="pledge-of-the-day bg-white campaign-det-sec-1">
        <Spin spinning={loading}>
          {
            id ?
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-5 col-md-5 col-sm-12">
                  <div className="pledge-banner-img">
                    <img className="img-fluid w-100 mb-4 mb-md-0" src={cover} alt="" />
                  </div>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-12 pl-md-5">
                  <h6 className="text-uppercase mb-1">Cause No {id || 'N/A'}</h6>
                  <h3 className="smbold mt-0">{title || 'N/A'}</h3>
                  <p>{story || 'N/A'}</p>
                  <div className="progres w-75">
                    <div className="progress-inner">
                      <div className="progress-bar" role="progressbar" style={{ width: `${progress || '0%'}` }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <h4 className="left-text">${amount || 0}<span>raised</span></h4>
                    <h4 className="left-right">{progress || 0}</h4>
                  </div>
                  <hr className="mt-4" />
                  <div className="flex">
                    <p className="float-left mb-0">
                      {daysGone}
                     </p>
                    <p className="float-right mb-0">
                      {visitors || 0} supporters
                     </p>
                  </div>
                </div>
              </div>
            </div> : ''
          }
        </Spin>
      </section>
    </div>
  );
}

export default CampaignDetails;
